import { ChartSquareBarIcon, UserGroupIcon } from '@heroicons/react/outline';
import Image from 'next/image';
import useLocale from 'next-translate/useTranslation';

const features = [
  {
    name: 'Monetization Opportunity:',
    description:
      'Earn your commission from your website, blog, social media following, or network.',
    icon: ChartSquareBarIcon,
  },
  {
    name: 'High Demand for AI Solutions',
    description:
      'Easy-Peasy.AI meets a growing need, making it easier to engage your audience.',
    icon: UserGroupIcon,
  },
  {
    name: 'Attractive Commission Rates',
    description: 'We offer 30% commission rates for sales.',
    icon: UserGroupIcon,
  },
  {
    name: 'Potential for Long-term Collaboration',
    description:
      'Successful affiliates establish long-term collaborations with us',
    icon: UserGroupIcon,
  },
  {
    name: 'Free to Join',
    description: 'Our program is free to join. You can start to earn now.',
    icon: UserGroupIcon,
  },
  {
    name: 'Track and Optimize',
    description:
      'We provide tracking tools to monitor your performance, including clicks, conversions, and earnings.',
    icon: UserGroupIcon,
  },
];

export default function Example() {
  const { t } = useLocale('affiliates');

  return (
    <div className='overflow-hidden bg-white py-32 dark:bg-slate-800'>
      <div className='mx-auto max-w-7xl px-6 lg:flex lg:px-8'>
        <div className='mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8'>
          <h2 className='text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl dark:text-slate-200'>
            {t('Why to join our affiliate program?')}
          </h2>
          <div className='lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8'>
            <p className='mt-0 text-lg leading-8 text-gray-600 dark:text-slate-400'>
              {t('Join thousands of creators and influencers who gain 30% of sales commission promoting EASY-PEASY.AI')}
            </p>

            <div className='mt-12 lg:col-span-2 lg:mt-12'>
              <dl className='space-y-10 sm:grid sm:grid-flow-col sm:grid-cols-2 sm:grid-rows-3 sm:gap-x-6 sm:gap-y-10 sm:space-y-0 lg:gap-x-8'>
                {features.map((feature) => (
                  <div key={feature.name} className='relative'>
                    <dt>
                      <feature.icon
                        className='absolute h-6 w-6 text-primary-500'
                        aria-hidden='true'
                      />
                      <p className='ml-9 text-lg font-medium leading-6 text-gray-900 dark:text-slate-200'>
                        {t(feature.name)}
                      </p>
                    </dt>
                    <dd className='ml-9 mt-2 text-base text-gray-500 dark:text-slate-400'>
                      {t(feature.description)}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>

            <div className='mt-10 flex'>
              <a
                href='https://easy-peasy-ai.getrewardful.com/signup'
                target='_blank'
                className='rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                rel='noreferrer'
              >
                {t('Start to earn now')} <span aria-hidden='true'>&rarr;</span>
              </a>
            </div>
          </div>
          <div className='hidden sm:flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents'>
            <div className='w-0 flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end'>
              <Image
                src='/images/ARKBAAB about Easy-Peasy.AI.png'
                alt=''
                width={400}
                height={600}
                className='aspect-[3/5] w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover'
              />
            </div>
            <div className='contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8'>
              <div className='order-first flex w-64 flex-none justify-end self-end lg:w-auto'>
                <Image
                  src='/images/maxresdefault.jpg'
                  alt=''
                  width={400}
                  height={600}
                  className='aspect-[7/4] w-[24rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover'
                />
              </div>
              <div className='flex w-96 flex-auto justify-end lg:w-auto lg:flex-none'>
                <Image
                  src='/images/CINETECH about Easy-Peasy.AI.png'
                  alt=''
                  width={400}
                  height={600}
                  className='aspect-[7/4] w-[32rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover'
                />
              </div>
              <div className='hidden sm:block sm:w-0 sm:flex-auto lg:w-auto lg:flex-none'>
                <Image
                  src='/images/mqdefault.jpg'
                  alt=''
                  width={400}
                  height={600}
                  className='aspect-[5/3] w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
